// extracted by mini-css-extract-plugin
export default {"registrationForm":"RegisterForm_registrationForm__OEDn-","form":"RegisterForm_form__s7yIo","termsAndConditionsMessage":"RegisterForm_termsAndConditionsMessage__5iB3d"};